<template>
  <el-checkbox-group v-model="formData[questions]" @change="handleChange">
    <el-checkbox style="display: block;" v-for="items in item.children" :key="items.id" :label="items.value" :name="items.value">{{ items.label }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    questions: {
      type: String,
      default: 'question_7'
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('handleChange', e);
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border-color: #bfbfbf;

    &::after {
      width: 6px;
      height: 10px;
      left: 6px;
    }
  }

  .el-checkbox__label {
    font-size: 16px;
    color: #303133;
  }
}
</style>